module.exports = __webpack_public_path__ + "img/per-page.466cf36e.svg";